module.exports = __webpack_public_path__ + "img/calendar-gear.23c55786.svg";